









import { Vue, Component, Prop } from 'vue-property-decorator'
import { FormaDePagamento } from '@/models'
import { listaDeFormasDePagamento } from '@/shareds/shared-pagamento'

@Component
export default class SeletorDeFormaDePagamento extends Vue {
	@Prop({ type: Boolean, default: false}) mostraPagamentoTEF!: boolean

	get formas(): FormaDePagamento[] {
		let formasListadas = listaDeFormasDePagamento

		if (this.mostraPagamentoTEF) {
			formasListadas = formasListadas.filter(f => f !== 'TEF Crédito' && f !== 'TEF Débito' && f !== 'TEF Pix')
		}

		return formasListadas
	}
}
